import { NoResult } from '@devex/devex-shared';
import { HttpService } from './http-service';
import { ShippingRule } from '../../shared/model/shipping-rule';
import { ProductsInfo } from '../../shared/model/products-info';
import { Variant } from '../../shared/model/variant';
import { ProductsColumnProperties } from '../../shared/model/products-column-properties';
import { ProductsValuesAndProperties } from '../models/products-values-and-properties';
import { Variants } from '../../shared/model/variants';

export class ShippingRulesService {
	public static readonly id = 'shipping-rules-service';

	public constructor(private readonly _httpService: HttpService) {}

	public async get(): Promise<ShippingRule[]> {
		const response = await this._httpService.get<ShippingRule[]>('api/shipping-rules');
		return response;
	}

	public async getAllProducts(): Promise<ProductsColumnProperties> {
		const response = await this._httpService.get<ProductsColumnProperties>('api/products/all');
		return response;
	}

	public async getProductVariants(value: string, property: string): Promise<Variant[]> {
		const encodedValue = encodeURIComponent(value);

		const response = await this._httpService.get<Variant[]>(`api/products/${encodedValue}/${property}/variants`);

		return response;
	}

	public async getAllProductVariants(productsValuesAndProperties: ProductsValuesAndProperties): Promise<Variants> {
		const response = await this._httpService.postWithResponse<Variants>('api/products/variants', { productsValuesAndProperties });
		return response;
	}

	public async getRuleProducts(value: string, property: string): Promise<ProductsInfo[]> {
		const encodedValue = encodeURIComponent(value);
		const products = await this._httpService.get<ProductsInfo[]>(`api/products/${encodedValue}/${property}`);
		return products;
	}

	public async save(shippingRules: ShippingRule[]): Promise<NoResult> {
		await this._httpService.post('api/shipping-rules', shippingRules);
		return NoResult.instance;
	}
}
